import React from 'react';
import OnboardingLayout from '../../components/Layout/Onboarding/OnboardingLayout';
import OnboardingPage from './OnboardingPage';
import styled from 'styled-components';
import { logger } from '../../utils/logger';

const Onboarding = () => {
  logger.log('being rendered');
  return (
    <OnboardingLayout>
      <OnboardingPage />
    </OnboardingLayout>
  );
};

export default Onboarding;
